<script lang="ts" setup>
import Slide from './components/sliders/index.vue'
import Brain from './components/brain/index.vue'
import Industry from './components/industry/index.vue'
import OnLineAndOffLine from './components/onLineAndOffLine/index.vue'
</script>

<template>
  <div>
    <!-- 头 -->
    <Slide />
    <!-- 三大主营业务 -->
    <Brain />
    <!-- 我们的优势 -->
    <Industry />
    <!-- 下载 -->
    <OnLineAndOffLine />
  </div>
</template>

<style scoped></style>
